import { IDocumentService } from "../../../domain/developer";
import { IDocumentReferable } from "../../../domain/document";
import { IItem } from "../../../domain/document/items";
import { IContentSource } from "../../../domain/drawing";
import { ObjectTranslator } from "../../document/ver2/ObjectTranslator";
import { DebugDocumentSource } from "./DebugDocumentSource";

export class DocumentService implements IDocumentService {
  constructor(private readonly _getToken: () => string) {
    this._objectTranslator = new ObjectTranslator(_getToken);
  }

  private readonly _objectTranslator: ObjectTranslator;

  reloadDocumentItem(seed: any, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    return this._objectTranslator.toObjectItem(
      seed,
      formatId,
      groupId,
      documentId,
      executionMode);
  }

  translateDocumentItem(item: IItem): any {
    return this._objectTranslator.toItemBean(item);
  }

  async createPreviewSource(document: IDocumentReferable): Promise<IContentSource> {
    return new DebugDocumentSource(this._getToken, document.patientNo, document.id, document.edition, "preview");
  }

  async createPrintSource(document: IDocumentReferable): Promise<IContentSource> {
    return new DebugDocumentSource(this._getToken, document.patientNo, document.id, document.edition, "print");
  }

  async createOriginalSource(document: IDocumentReferable): Promise<IContentSource> {
    return new DebugDocumentSource(this._getToken, document.patientNo, document.id, document.edition, "original");
  }
}
